import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {LoginService} from '@services/login.service';
import {PermissionService} from '@services/permission.service';
import {AppConfigService} from '@shared/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private loginService: LoginService,
    private appConfigService: AppConfigService,
    private permissionService: PermissionService,
    private router: Router
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.loginService.isLoggedIn()) {
      this.router.navigate(['/login']);
      this.loginService.resetLogin(true);
      return false;
    }

    if (!this.isRouteAllowed(next.root)) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }

  private isRouteAllowed(route: ActivatedRouteSnapshot): boolean {
    if (
      route.data?.configurationKeys?.length
      && !this.appConfigService.hasConfigurationsEnabled(route.data.configurationKeys, route.data.configurationKeysOperation)
    ) {
      return false;
    }

    if (
      route.data?.hideConfigurationKeys?.length
      && this.appConfigService.hasConfigurationsEnabled(route.data.hideConfigurationKeys, route.data.hideConfigurationKeysOperation)
    ) {
      return false;
    }

    if (
      route.data?.permissionKeys?.length
      && !this.permissionService.hasPermissions(route.data.permissionKeys, route.data.permissionKeysOperation)
    ) {
      return false;
    }

    let isRouteAllowed = true;
    if (route.children?.length) {
      // We take the first child since there will only be one child after another up to the route we are accessing.
      isRouteAllowed = this.isRouteAllowed(route.children[0]);
    }

    return isRouteAllowed;
  }
}
